const getBreakpoints = () => {
    return {
        values: {
            xs: 0,
            sm: 520,
            md: 900,
            lg: 1200,
            xl: 1536,
        },
    }
}

export default getBreakpoints;
